import { useContext, useMemo } from 'react';
import { AdminTable, AdminTableContext } from '../../AdminTable';
import { AdminProjects } from '@platform/client';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { AdminProjectTeamMatchRecord } from '@platform/client/schemas';
import { NoRecordsFoundTabContent, ProfileTabContainer } from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';
import { TeamLink } from '../teams/TeamsResultsTab';
import { TeamMatchLink } from '../teams-matching/TeamsMatchAdmin';

const columnHelper = createColumnHelper<AdminProjectTeamMatchRecord>();
export const TeamMatchingTabContent = ({ projectId }: { projectId: number }) => {
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const {
    data: teamMatchData,
    isSuccess,
    isLoading,
    isError,
  } = AdminProjects.useGetProjectTeamMatchData({
    project_id: projectId,
    page: adminQueryOptionsV2.page,
    limit: adminQueryOptionsV2.limit,
    sort: adminQueryOptionsV2.sort,
  });
  const columns = useMemo(
    () =>
      [
        columnHelper.accessor('discoveryId', {
          header: 'Id',
          cell: (info) => <TeamMatchLink discoveryId={info.getValue()} />,
          size: 5,
        }),
        columnHelper.accessor('representativeName', {
          header: 'Representative',
          cell: (info) => info.getValue(),
          size: 150,
        }),
        columnHelper.accessor('teamId', {
          header: 'Team',
          cell: ({ row }) => (
            <TeamLink teamId={row.original.teamId} cohortId={row.original.cohortId} />
          ),
          size: 10,
        }),
        columnHelper.accessor('myProjectsStatus', {
          header: 'Status',
          cell: (info) => info.getValue(),
          size: 10,
        }),
        columnHelper.accessor('myProjectsStatusDate', {
          header: 'Status date',
          cell: (info) => formatDateStr(info.getValue()),
          size: 150,
        }),
      ] as ColumnDef<AdminProjectTeamMatchRecord>[],
    [],
  );

  return (
    <ProfileTabContainer>
      {isSuccess && teamMatchData?.matchRecords.length === 0 ?
        <NoRecordsFoundTabContent recordType='project' />
      : <AdminTable
          isError={isError}
          isLoading={isLoading}
          isSuccess={isSuccess}
          columns={columns}
          data={teamMatchData?.matchRecords || []}
          isSimple
          filteredCount={teamMatchData?.totalCount ?? 0}
        />
      }
    </ProfileTabContainer>
  );
};
